import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createHotel,
  getHotel,
  resetState,
  updateHotel,
} from "../features/TransportScilce";
let schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  title: yup.string().required("Title is Required"),
  information:  yup
  .string()
  .test('word-limit', 'Website must have at most 150 words', value => {
    if (!value) return true; // Allow empty value
    return value.trim().split(/\s+/).length <= 150;
  }),
  // video: yup.string().required("Video is Required"),
  amenities: yup.array().min(1, "Please select at least one amenity"),
  image: yup.mixed().required("Home Image is Required"),
  images: yup.mixed().required("All Image is Required")
});
const AddNewscat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsCatId = location.pathname.split("/")[3];
  const newNewsCategory = useSelector((state) => state.laxuryHotelS);
  const [imageErrorone, setImageErrorone] = useState("");
  const [imageErrortwo, setImageErrortwo] = useState("");
  const {
    isSuccess,
    isError,
    isLoading,
    createdHotel,
    updatedHotel,
    hotelamenities,
    hotelinformation,
    hoteltitle,
    hotelname
  } = newNewsCategory;
  const token = useSelector((state) => state.autht.token);
  useEffect(() => {
    if (getNewsCatId !== undefined) {
      dispatch(getHotel(getNewsCatId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsCatId]);
  useEffect(() => {
    if (isSuccess && createdHotel) {
      toast.success("Transport Added Successfullly!");
      navigate("/Transport/Transportlist");
    }
    if (isSuccess && updatedHotel) {
      toast.success("Transport Updated Successfullly!");
      navigate("/Transport/Transportlist");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);
  const formik = useFormik({ 
    enableReinitialize: true,
    initialValues: {
      name: hotelname|| "",
      title:hoteltitle||"",
      information:hotelinformation || "",
      amenities: hotelamenities|| [],
      image:null,
      images: [],
      token: token
    },
    validationSchema: schema,
    onSubmit: (values) => {
      console.log(values.amenities)
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("title", values.title);
      formData.append("information", values.information);
      formData.append("home_image", values.image);
      values.images.forEach((image) => formData.append("image", image));
      values.amenities.forEach((amenity) => formData.append("amenities[]", amenity));
      formData.append("token",token);
      formData.append("id",getNewsCatId);
     console.log(formData);
      if (getNewsCatId !== undefined) {
        dispatch(updateHotel(formData));
        dispatch(resetState());
      } else {
        dispatch(createHotel(formData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  const amenitiesOptions = [
    { value: "First aid kit", label: "First aid kit" },
    { value: "Fire extinguisher", label: "Fire extinguisher" },
    { value: "Tissue papers", label: "Tissue papers" },
    { value: "Organic fragrance", label: "Organic fragrance" },
    { value: "Cleaned & bacteria free interior", label: "Cleaned & bacteria free interior" },
    { value: "Mineral water in cars", label: "Mineral water in cars" },
    { value: "Newspaper and Magazines", label: "Newspaper and Magazines" },
    { value: "Hand sanitizers", label: "Hand sanitizers" },
    { value: "Basket on demand", label: "Basket on demand" },

   

  ];
  return (
    <div>
      <h3 className="mb-4  title">
        {getNewsCatId !== undefined ? "Edit" : "Add"} Transport
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="name"
            onChng={formik.handleChange("name")}
            onBlr={formik.handleBlur("name")}
            val={formik.values.name}
            label="Enter Name"
          />
          <div className="error">
            {formik.touched.name && formik.errors.name}
          </div>


          <CustomInput
            type="text"
            label="Enter Title"
            name="title"
            onChng={formik.handleChange("title")}
            onBlr={formik.handleBlur("title")}
            val={formik.values.title}
          />
          <div className="error">{formik.touched.title && formik.errors.title}</div>



           

          <CustomInput
            type="text"
            label="Enter Information About "
            name="information"
            onChng={formik.handleChange("information")}
            onBlr={formik.handleBlur("information")}
            val={formik.values.information}
          />
          <div className="error">{formik.touched.information && formik.errors.information}</div>

          {/* <CustomInput
            type="text"
            label="Enter Video Youtube ID "
            name="video"
            onChng={formik.handleChange("video")}
            onBlr={formik.handleBlur("video")}
            val={formik.values.video}
          />
          <div className="error">{formik.touched.video && formik.errors.video}</div> */}

          <div className="mt-4">
            <label className="form-label">Amenities:</label>
            <div>
              {amenitiesOptions.map((option) => (
                <div key={option.value} className="form-check form-check-inline"> {/* Updated for horizontal display */}
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={option.value}
                    value={option.value}
                    checked={formik.values.amenities.includes(option.value)}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      const newValue = isChecked
                        ? [...formik.values.amenities, option.value]
                        : formik.values.amenities.filter((item) => item !== option.value);
                      formik.setFieldValue("amenities", newValue);
                    }}
                  />
                  <label className="form-check-label" htmlFor={option.value}>
                    {option.label}
                  </label>
                </div>
              ))}

            </div>
            <div className="error">{formik.touched.amenities && formik.errors.amenities}</div>
          </div>

          <div className="mt-4">
            <label htmlFor="image" className="form-label">Select Home Image file</label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                formik.setFieldValue("image", e.currentTarget.files[0]);
                setImageErrorone(""); // Clear image error when a new file is selected
              }}
              className="form-control"
            />
            <div className="error">{formik.touched.image && formik.errors.image}</div>
          </div>

          <div className="mt-4">
            <label htmlFor="image1" className="form-label">Select All Image file</label>
            <input
              type="file"
              id="images"
              name="images"
              accept="image/*"
              multiple
              onChange={(e) => {
                formik.setFieldValue("images",  Array.from(e.currentTarget.files));
                setImageErrortwo(""); // Clear image error when a new file is selected
              }}
              className="form-control"
            />
            <div className="error">{formik.touched.images && formik.errors.images}</div>
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
            disabled={isLoading}
          >
            {isLoading && (
              <div className="loader"></div>
            )}
            {isLoading ? "" : getNewsCatId !== undefined ? "Edit" : "Add"} Transport
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewscat;
